import { ApiSuccessResult } from "@/common/api/ApiResult.model";
import { InformationType } from "@/common/models";
import { UserStatus } from "@/views/admins/data/models";

import { Investigation } from "@/views/investigation/data/models";
import axios from "axios";

export interface ApiResolverPayload<T> {
  type: RestCallsKey;
  payload: T;
}

export type CallResolverFn = (payload?: any) => Promise<ApiSuccessResult<any>>;

export type RestCallsKey =
  | "refreshtoken"
  | "get-l0-labels-with-policies"
  | "employee-dep-by-id"
  | "org-entities-scope"
  | "org-departments"
  | "all-content-labels"
  | "dynamics-labels"
  | "all-virtual-labels"
  | "all-abstract-labels"
  | "get-report-types"
  | "get-reports"
  | "gen-report"
  | "get-report-by-id"
  | "delete-report"
  | "share-report"
  | "get-apps"
  | "pin-app"
  | "unpin-app"
  | "turnon-app"
  | "turnoff-app"
  | "label-and-insight-desc"
  | "get-all-labels"
  | "apps-modal-descs"
  | "get-org-settings"
  | "all-insights"
  | "update-insight"
  | "update-org-settings"
  | "auditlog-url"
  | "auditlog-code"
  | "summary"
  | "mip-manual-label"
  | "mip-url"
  | "mip-code"
  | "mip-success"
  | "user-status"
  | "export-as-csv"
  | "csv-job-status"
  | "l0"
  | "create-label"
  | "update-label"
  | "delete-label"
  | "apply-label-to-item"
  | "update-label-sensitivity"
  | "accounts"
  | "admins.get"
  | "admins.invite"
  | "admins.change"
  | "admins.get-restrictions"
  | "admins.update-restrictions"
  | "investigations.get"
  | "investigations.update"
  | "investigations.isExist"
  | "investigations.create"
  | "investigations.delete"
  | "sharing.create"
  | "sharing.update"
  | "sharing.delete"
  | "events.mark"
  | "events.unmark"
  | "integration.get"
  | "integration.connect"
  | "integration.disconnect"
  | "mip-get-cognni-labels"
  | "mip-get-labels-tree"
  | "mip-cognni-labels-ready-state"
  | "mip-update-cognni-label"
  | "mip-get-label-overrides"
  | "mip-get-all-label-overrides"
  | "mip-update-label-overrides"
  | "mip-get-labels"
  | "mip-update-label"
  | "trial-start"
  | "activate-onedrive-scanner"
  | "mip_setup_option"
  | "get-mip-coggni-label-mapping"
  | "create-mip-coggni-label-mapping"
  | "label-api-beta-mapping"
  | "label-api-beta-override"
  | "label-api-beta-delete-mapping"
  | "delete-mip-coggni-label-mapping"
  | "pick-mip-setup-option"
  | "get-edition-status"
  | "onprem-org-license"
  | "onprem-org-usage"
  | "onprem-get-instances"
  | "onprem-get-instance-license"
  | "onprem-create-instance"
  | "onprem-license-details"
  | "onprem-get-settings"
  | "onprem-update-settings"
  | "onprem-get-instance-repos"
  | "familiarity-get-entities-for-status"
  | "familiarity-get-organization-entities-for-status"
  | "familiarity-get-user-email"
  | "familiarity-update-entity-status"
  | "familiarity-get-entity-status"
  | "familiarity-counters"
  | "users-2fa-get-for-status"
  | "users-2fa-update-user-validation-status"
  | "threat_tags_get"
  | "threat_tags_update"
  | "threat_tags_delete"
  | "total-managed-entity"
  | "justification.body"
  | "justification.send"
  | "justification.list"
  | "justification.one"
  | "risky-users.for-l0"
  | "risky-users.for-l0-2"
  | "risky-users.status-list"
  | "risky-users.change-activate-for-l0"
  | "risky-users.next-send-date"
  | "mass-download.counters-summary"
  | "mass-download.for-l0"
  | "mass-download.status-list"
  | "mass-download.change-activate-for-l0"
  | "mass-download.next-send-date"
  | "justification-policy.list"
  | "justification-policy.change-activate-for-l0"
  | "recommendations.get-info-types"
  | "recommendations.update-info-types"
  | "recommendations.set-status"
  | "recommendations.get-audit-logs"
  | "recommendations.get-list"
  | "recommendations.get-archived-list"
  | "recommendations.get-next"
  | "recommendations.get-strategies"
  | "recommendations.update-strategy"
  | "features.unprotected-mfa-users.get-list"
  | "features.unprotected-mfa-users.notify-user"
  | "accounts-counters"
  | "preferences.update"
  | "info-motion.by-departments.list"
  | "info-motion.by-info-types.list"
  | "info-motion.dep-to-dep"
  | "info-motion.dep-to-org"
  | "features.ghost-users.get-list"
  | "features.ghost-unprotected-users.get-list"
  | "folders-context-labels.get"
  | "folders-context-labels.attach-to-folder"
  | "folders-context-labels.delete-from-folder"
  | "folders-context-labels.create"
  | "folders-context-labels.status"
  | "cluster.set-label"
  | "cluster.get-label"
  | "cluster.remove-label"
  | "content-labels.create"
  | "content-labels.delete"
  | "content-labels.update-texts"
  | "info-at-rest.providers.get-summary"
  | "info-at-rest.providers.exposure-counters"
  | "info-at-rest.providers.setup-azure"
  | "info-at-rest.providers.setup-aws"
  | "info-at-rest.providers.sharepoint-enable"
  | "info-at-rest.providers.sharepoint-disable"
  | "info-at-rest.folders-trust"
  | "info-at-rest.folders-trust.users-permissions"
  | "info-at-rest.folders-trust.users-permissions-users"
  | "info-at-rest.folders-trust.remove-user-permissions"
  | "info-at-rest.folders-trust.restore-user-permissions"
  | "info-at-rest.folders-trust.users-permissions-users-familiarities"
  | "info-in-motion.connectors-status"
  | "info-in-motion.ask-for-connector"
  | "info-in-motion.connect-gmail"
  | "info-in-motion.connect-gdrive"
  | "info-in-motion.connect-slack"
  | "info-at-rest.providers-status"
  | "it-scripts.vars-map"
  | "it-scripts.scripts"
  | "it-scripts.full-script"
  | "it-scripts.get-entities"
  | "it-scripts.get-entities-job-status"
  | "it-scripts.get-entities-job-result"
  | "policy-email-template.get"
  | "policy-email-template.update"
  | "security-posture.get-status"
  | "security-posture.update-labels-for-posture"
  | "security-posture.get-selected-labels-status"
  | "security-posture.update-status"
  | "security-posture.get-issues"
  | "security-posture.ghost-users"
  | "security-posture.privileged-users"
  | "security-posture.identity-ghost"
  | "security-posture.identity-ghost-count"
  | "security-posture.active_accounts_res"
  | "security-posture.identity-active"
  | "security-posture.identity-active-count"
  | "security-posture.identity-ghost-account-list"
  | "security-posture.identity-active-account-list"
  | "security-posture.data-protection-files-sharepoint"
  | "security-posture.data-protection-files-onpremise"
  | "security-posture.information-compliance-risky-users"
  | "security-posture.information-compliance-mass-downloads"
  | "security-posture.information-compliance-high-severity-incidents"
  | "csv-reports.get_all"
  | "csv-reports.get_some"
  | "csv-reports.delete"
  | "csv-reports.generate"
  | "csv-reports.download"
  | "csv-reports-schedule.get_all"
  | "csv-reports-schedule.create"
  | "csv-reports-schedule.update"
  | "csv-reports-schedule.delete"
  | "reports.generate"
  | "reports.get_all_templates"
  | "reports.get_all_template_sections"
  | "reports.create_template"
  | "reports.delete"
  | "reports.update_template"
  | "reports.delete_template"
  | "reports.get_all"
  | "reports.get_status"
  | "executive-reports.get_external_labeling_report_ref"
  | "executive-reports.get_external_labeling_domain_separated_report_ref"
  | "executive-reports.get_organizations_supplementary_data"
  | "scheduled-reports.risky_events.get"
  | "scheduled-reports.risky_events.set"
  | "security-posture.information-access-ghost-access"
  | "security-posture.information-access-mass-exposed"
  | "security-posture.information-access-ghost-access-list"
  | "security-posture.information-access-mass-exposed-list"
  | "security-posture.session_for_source_and_time_frame"
  | "data-security.sensitive-storage-accounts-count"
  | "data-security.sensitive-storage-accounts-items"
  | "data-security.unprotected-databases-count"
  | "data-security.unprotected-databases-items"
  | "data-security.unprotected-s3-items"
  | "cloud-app-security.data-exfiltration"
  | "cloud-app-security.misconfigurations-count"
  | "cloud-app-security.unauthorized-data-access"
  | "cloud-app-security.information-exposure"
  | "conv-ai.query"
  | "conv-ai.history"
  | "findings.employees"
  | "findings.organizations"
  | "findings.folders_for_label"
  | "findings.buckets"
  | "findings.files"
  | "findings.person_share_encrypted_files"
  | "findings.files_search"
  | "findings.events"
  | "findings.action_number"
  | "data-source.get-source-brief"
  | "data-source.get-source-acquisition-descriptor"
  | "data-sources.load-all-sources-status"
  | "data-sources.get-source-connections"
  | "data-sources.remove-connection"
  | "data-sources.update-connection"
  | "data-sources.setup-source-via-keys"
  | "data-sources.get-source-token-setup-url"
  | "data-sources.setup-source-via-token"
  | "data-sources.add-connection"
  | "data-sources.stop-scan"
  | "data-sources.start-scan"
  | "data-source.get-source-sessions"
  | "data-source.get-source-live-sessions"
  | "data-source.get-source-history-sessions"
  | "overview.sensitive-info-count"
  | "containers.get"
  | "databases.get"
  | "servers.get"
  | "buckets.get"
  | "storages.get"
  | "findings.count"
  | "findings.search"
  | "findings.entities"
  | "cloud-playbooks.all"
  | "cloud-playbooks.stop-instance-building"
  | "cloud-playbooks.instances"
  | "cloud-playbooks.create-instance"
  | "cloud-playbooks.instance-status"
  | "cloud-playbooks.run-instance"
  | "cloud-playbooks.cancel-instance-run"
  | "cloud-playbooks.download-instance-data"
  | "cloud-playbooks.create-custom-instance"
  | "cloud-playbooks.upload-instance-data"
  | "cloud-playbooks.get-data-url"
  | "cloud-playbooks.specific-instances"
  | "overview.total_counters"
  | "playbook.audit"
  | "sp-permissions.status-for-label"
  | "on-prem.get_duplicated_items"
  | "on-prem.get_files_labeling"
  | "on-prem.get_files_age"
  | "on-prem.search_files"
  | "on-prem.get_information_board"
  | "on-prem.get_personal_information_board"
  | "on-prem.all_pii_labels_count"
  | "custom-labels.analysis"
  | "custom-labels.send-created-label-to-teach"
  | "custom-labels.remove"
  | "label-teach.folder-path-analysis"
  | "label-teach.label-analysis-status"
  | "label-teach.send-folder-paths"
  | "support.get_impersonation_status"
  | "support.revoke_impersonation"
  | "support.approve_impersonation"
  | "support.provide_impersonation"
  | "entity-investigation.sub_folders_count"
  | "entity-investigation.sub_folders"
  | "folder-forensic.children.count"
  | "folder-forensic.children.list"
  | "get-mappable-labels";

const resolvers: Map<RestCallsKey, CallResolverFn> = new Map();

//#region  integrations
const getIntegrations: CallResolverFn = async () => {
  const res = await axios.get("/integrations");
  return {
    success: true,
    value: res.data,
  };
};

const disconnectIntegration: CallResolverFn = async (service: string) => {
  await axios.delete(`/integrations/${service}`);
  return {
    success: true,
    value: true,
  };
};
//#endregion

//#region INFO
const getUserStatus: CallResolverFn = async () => {
  const res = await axios.get("/user/info");
  return {
    success: true,
    value: res.data,
  };
};
//#endregion

//#region  LABELS
const getL0Labels: CallResolverFn = async () => {
  const res = await axios.get("/labels/L0");
  return {
    success: true,
    value: (res.data as InformationType[]).map((l) => ({
      ...l,
      labelName: l.labelName.split(" ")[0],
    })),
  };
};
//#endregion

//#region  ACCOUNTS
const getAccounts: CallResolverFn = async () => {
  const res = await axios.get("/accounts");
  const { value, cursor = "", total = 0 } = res.data;

  return {
    success: true,
    value: {
      count: total,
      cursor,
      objects: value.map((item: any) => ({
        ...item,
        id: item.subscriptionId,
        name: item.displayName,
        email: item.externalId,
        checked: false,
      })),
    },
  };
  /*  return {
    success: true,
    value: res.data,
  }; */
};
//#endregion

//#region  ADMINS
const getAdmins: CallResolverFn = async () => {
  const res = await axios.get("/admins");
  return {
    success: true,
    value: res.data,
  };
};

const adminsInvite: CallResolverFn = async (emails: string[]) => {
  await axios.post("/admins/invite", { emails });
  return {
    success: true,
    value: null,
  };
};

const adminsChange: CallResolverFn = async (p: {
  id: number;
  status: UserStatus;
}) => {
  await axios.put(`/admins/change-status/${p.id}/status/${p.status}`);
  return {
    success: true,
    value: null,
  };
};
//#endregion

//#region investigations
const getInvestigations: CallResolverFn = async () => {
  const res = await axios.get("/investigations");
  return {
    success: true,
    value: (res.data.objects as Investigation[]).map((inv) => {
      return {
        // @ts-ignore
        type: inv.content.type,
        ...inv,
      };
    }),
  };
};

const isInvestigationExist: CallResolverFn = async (id: string) => {
  const res = await axios.get(`/investigations/${id}`);
  return {
    success: res.data.isExist,
    value: true,
  };
};

const createInvestigation: CallResolverFn = async (inv: Investigation) => {
  const res = await axios.post("/investigations", { ...inv });
  return {
    success: true,
    value: res.data,
  };
};

const deleteInvestigation: CallResolverFn = async (id: string) => {
  await axios.delete(`/investigations/${id}`);
  return {
    success: true,
    value: true,
  };
};
//#endregion

//#region events mark
const markEvent: CallResolverFn = async () => {
  return {
    success: true,
    value: true,
  };
};

const unmarkEvent: CallResolverFn = async () => {
  return {
    success: true,
    value: true,
  };
};
//#endregion

//#region investigation sharing
const createInvSharing: CallResolverFn = async (inv: Investigation) => {
  return {
    success: true,
    value: inv.id,
  };
};

const updateInvSharing: CallResolverFn = async (inv: Investigation) => {
  return {
    success: true,
    value: inv.id,
  };
};

const deleteInvSharing: CallResolverFn = async (id: string) => {
  return {
    success: true,
    value: true,
  };
};
//#endregion

// rest resolvers

resolvers.set("integration.get", getIntegrations);
resolvers.set("integration.disconnect", disconnectIntegration);

resolvers.set("user-status", getUserStatus);

resolvers.set("l0", getL0Labels);

resolvers.set("accounts", getAccounts);

resolvers.set("admins.get", getAdmins);
resolvers.set("admins.invite", adminsInvite);
resolvers.set("admins.change", adminsChange);

resolvers.set("investigations.get", getInvestigations);
resolvers.set("investigations.isExist", isInvestigationExist);
resolvers.set("investigations.create", createInvestigation);
resolvers.set("investigations.delete", deleteInvestigation);

resolvers.set("sharing.create", createInvSharing);
resolvers.set("sharing.update", updateInvSharing);
resolvers.set("sharing.delete", deleteInvSharing);
resolvers.set("events.mark", markEvent);
resolvers.set("events.unmark", unmarkEvent);

const getExternalLabelingReportRef: CallResolverFn = async () => {
  return {
    success: true,
    value: { has_labeling: false, msg: "demo env: labeling report not mocked" },
  };
};

const getExternalLabelingDomainSeparatedReportRef: CallResolverFn =
  async () => {
    return {
      success: true,
      value: {
        has_labeling: false,
        msg: "demo env: domain separated labeling report not mocked",
      },
    };
  };

const getOrganizationsSupplementaryData: CallResolverFn = async () => {
  return {
    success: true,
    value: { alias: "" },
  };
};

resolvers.set(
  "executive-reports.get_external_labeling_report_ref",
  getExternalLabelingReportRef
);
resolvers.set(
  "executive-reports.get_external_labeling_domain_separated_report_ref",
  getExternalLabelingDomainSeparatedReportRef
);
resolvers.set(
  "executive-reports.get_organizations_supplementary_data",
  getOrganizationsSupplementaryData
);

export const callResolver = async <T, U>(
  p: ApiResolverPayload<T>
): Promise<ApiSuccessResult<U>> => {
  const resolver = resolvers.get(p.type) as CallResolverFn;
  const res: ApiSuccessResult<U> = await resolver(p.payload);
  return res;
};
